import { getErrorProps } from "../../helpers";

import { Error } from "./Error";

import type { FallbackProps, TError } from "./ErrorFallback.types";

export const ErrorFallback = (props: FallbackProps) => {
  const { error, resetErrorBoundary } = props;
  const errorProps = getErrorProps(error);

  const createActionHandler = (
    _error: TError,
    resetErrorBoundary: () => void
  ): (() => void) => {
    //TOD: customize it based on error types
    return () => {
      resetErrorBoundary();
    };
  };

  return (
    <Error
      {...errorProps}
      buttonAction={createActionHandler(errorProps, resetErrorBoundary)}
    />
  );
};
